import { Typography } from '@mui/material'
import { DataGrid, GridOverlay } from '@mui/x-data-grid'
import React, { useMemo } from 'react'

import {
  sharedColumnProps,
  sharedGridProps
} from 'components/status-checks/common/monitor-search-list-utils'
import { MonitorSearchListResult } from 'components/status-checks/form/status-check/common/MonitorSearchListResult'

export interface MonitorListGridRow {
  labels: string[] | null
  title: string
  uid: string
}

type MonitorSearchListProps<TGridRowModel> = {
  isLoading?: boolean
  pageSize?: number
  rows: TGridRowModel[]
  selectedRowId: string | undefined
  onClick(id: string): void
}

const DEFAULT_MONITOR_SEARCH_LIST_PAGE_SIZE = 10

export function MonitorSearchList<TGridRowModel extends MonitorListGridRow>({
  isLoading = false,
  pageSize = DEFAULT_MONITOR_SEARCH_LIST_PAGE_SIZE,
  rows,
  selectedRowId,
  onClick
}: MonitorSearchListProps<TGridRowModel>) {
  const columns = useMemo(
    () => [
      {
        ...sharedColumnProps,
        renderCell: ({ row }) => (
          <MonitorSearchListResult
            data-testid={`search-result-item-${row.uid}`}
            name={row.title}
            tags={row.labels}
          />
        )
      }
    ],
    []
  )

  return (
    <DataGrid<TGridRowModel>
      {...sharedGridProps}
      columns={columns}
      components={{
        NoRowsOverlay: () => (
          <GridOverlay>
            {rows && !rows.length ? (
              <Typography>
                No results found that match the provided query
              </Typography>
            ) : (
              <Typography>Enter a term to search for results</Typography>
            )}
          </GridOverlay>
        )
      }}
      getRowId={(row) => row.uid}
      hideFooter={rows.length < pageSize}
      loading={isLoading}
      pageSize={pageSize}
      rows={rows}
      rowsPerPageOptions={[pageSize]}
      selectionModel={selectedRowId ? [selectedRowId] : []}
      onCellClick={(params) => onClick(params.row.uid)}
    />
  )
}
